import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom"
import Web3 from "web3";
import SupplyChainABI from "./artifacts/SupplyChain.json"

function Supply() {
    const history = useHistory()
    useEffect(() => {
        loadWeb3();
        loadBlockchaindata();
    }, [])

    const [currentaccount, setCurrentaccount] = useState("");
    const [loader, setloader] = useState(true);
    const [SupplyChain, setSupplyChain] = useState();
    const [PRODUCT, setPRODUCT] = useState();
    const [ProductStage, setProductStage] = useState();
    const [ID, setID] = useState();


    const loadWeb3 = async () => {
        if (window.ethereum) {
            window.web3 = new Web3(window.ethereum);
            await window.ethereum.enable();
        } else if (window.web3) {
            window.web3 = new Web3(window.web3.currentProvider);
        } else {
            window.alert(
                "Non-Ethereum browser detected. You should consider trying MetaMask!"
            );
        }
    };

    const loadBlockchaindata = async () => {
        setloader(true);
        const web3 = window.web3;
        const accounts = await web3.eth.getAccounts();
        const account = accounts[0];
        setCurrentaccount(account);
        const networkId = await web3.eth.net.getId();
        const networkData = SupplyChainABI.networks[networkId];
        if (networkData) {
            const supplychain = new web3.eth.Contract(SupplyChainABI.abi, networkData.address);
            setSupplyChain(supplychain);
            var i;
            const productCtr = await supplychain.methods.productCtr().call();
            const product = {};
            const productStage = [];
            for (i = 0; i < productCtr; i++) {
                product[i] = await supplychain.methods.ProductStock(i + 1).call();
                productStage[i] = await supplychain.methods.showStage(i + 1).call();
            }
            setPRODUCT(product);
            setProductStage(productStage);
            setloader(false);
        }
        else {
            window.alert('Lo smart contract non è stato registrato sulla rete corrente')
        }
    }
    if (loader) {
        return (
            <div>
                <h1 className="wait">Caricamento...</h1>
            </div>
        )

    }
    const redirect_to_home = () => {
        history.push('/')
    }
    const handlerChangeID = (event) => {
        setID(event.target.value);
    }
  
    const handlerSubmitDistribute = async (event) => {
        event.preventDefault();
        try {
            var reciept = await SupplyChain.methods.Distribute(ID).send({ from: currentaccount });
            if (reciept) {
                loadBlockchaindata();
            }
        }
        catch (err) {
            alert("Errore!!!")
        }
    }
    const handlerSubmitRetail = async (event) => {
        event.preventDefault();
        try {
            var reciept = await SupplyChain.methods.Retail(ID).send({ from: currentaccount });
            if (reciept) {
                loadBlockchaindata();
            }
        }
        catch (err) {
            alert("Errore!!!")
        }
    }
    const handlerSubmitSold = async (event) => {
        event.preventDefault();
        try {
            var reciept = await SupplyChain.methods.sold(ID).send({ from: currentaccount });
            if (reciept) {
                loadBlockchaindata();
            }
        }
        catch (err) {
            alert("Errore!!!")
        }
    }
    return (
        <div>
            <span><b>Indirizzo Account corrente:</b> {currentaccount} </span>
            <span onClick={redirect_to_home} className="btn btn-outline-danger btn-sm"> HOME</span>
            <h6><b>Supply Chain Flow:</b></h6>
            <p>Inserimento Prodotto (Frantoio) -&gt; Distributore -&gt; Rivenditore -&gt; Consumatore</p>
            <table className="table table-sm table-dark">
                <thead>
                    <tr>
                        <th scope="col">ID/Lotto</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Descrizione</th>
                        <th scope="col">Current Processing Stage</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(PRODUCT).map(function (key) {
                        return (
                            <tr key={key}>
                                <td>{PRODUCT[key].id}</td>
                                <td>{PRODUCT[key].name}</td>
                                <td>{PRODUCT[key].description}</td>
                                <td>
                                    {
                                        ProductStage[key]
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            
           
           
            <h5><b>Step 2: Distribuisci</b> (Solo un Distributore registrato può eseguire questo step):-</h5>
            <form onSubmit={handlerSubmitDistribute}>
                <input className="form-control-sm" type="text" onChange={handlerChangeID} placeholder="Inserisci ID/Lotto" required />
                <button className="btn btn-outline-success btn-sm" onSubmit={handlerSubmitDistribute}>Distribuzione</button>
            </form>
            <hr />
            <br />
            <h5><b>Step 3: Vendi</b> (Solo un Rivenditore registrato può eseguire questo step):-</h5>
            <form onSubmit={handlerSubmitRetail}>
                <input className="form-control-sm" type="text" onChange={handlerChangeID} placeholder="Inserisci ID/Lotto" required />
                <button className="btn btn-outline-success btn-sm" onSubmit={handlerSubmitRetail}>In Vendita</button>
            </form>
            <hr />
            <br />
            <h5><b>Step 4: Segna come Venduto</b> (Solo un Rivenditore registrato può eseguire questo step):-</h5>
            <form onSubmit={handlerSubmitSold}>
                <input className="form-control-sm" type="text" onChange={handlerChangeID} placeholder="Inserisci ID/Lotto" required />
                <button className="btn btn-outline-success btn-sm" onSubmit={handlerSubmitSold}>Venduto</button>
            </form>
            <hr />
        </div>
    )
}

export default Supply
